<div fxLayout="column" fxLayoutGap="15px">
  <!-- Page Header -->
  <app-page-header
    [description]="'Manage industry categories and their specific industries for your ' + (offering?.label || 'offering') + '. Select which categories and industries are available for your tenants.'"
    [section]="'Industry Categories'"
    [title]="'Industry Category Management'">
  </app-page-header>

  <app-expanding-info-panel
    [type]="PanelType.INFO"
    [fullWidth]="true"
    (emitEvent)="moreInfoMessage = !moreInfoMessage"
    (onDisplayExpanded)="moreInfoMessage = $event"
    class="page-padding">

@if(moreInfoMessage){
<!--  class="body-1-default"-->
  <div class="fx-row mb-10">
    Control which industry options your tenants can select when setting up their profiles.
  </div>

    <span>What You Can Do:</span>

    <ul>
      <li><span>Use Built-in Categories:</span> Start with pre-configured industry categories and their industries. Show or hide them, and rename or update descriptions to match your terminology.</li>
      <li><span>Create Your Own:</span> Add custom categories and industries that are specific to your market or tenant base.</li>
      <li><span>Mix and Match:</span> Add your own industries to built-in categories, or build everything from scratch - whatever works best for your needs.</li>
      <li><span>Control Visibility:</span> Hide categories or industries that aren't relevant. Tenants won't see them as options, but any existing selections remain unchanged.</li>
      <li><span>Customize Labels:</span> Change display names and descriptions to use language that makes sense for your audience.</li>
    </ul>

    <span>Tips:</span>
    <ul>
      <li>Only show what's relevant to your tenant base</li>
      <li>Use clear names that tenants will recognize and understand</li>
      <li>Update periodically as your market focus evolves</li>
    </ul>
  }@else{
    Control which industry categories and industries your tenants can select, and customize how
      they're displayed.
  }
  </app-expanding-info-panel>

  <!-- Action Bar -->
  <div class="page-padding" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px"
       style="margin-bottom: 20px;">
    <span class="subtitle-default">Industries</span>
    <div fxLayoutGap="10px" fxFlexOffset="30px">
      <button class="button-action" mat-flat-button (click)="addNewCategory()" [disabled]="loader.loading$ | async">
        <span class="button-text">Add Category</span>
      </button>

      <!-- Save/Cancel Actions -->
      @if(isDirty){
        <button class="button-action-cancel" mat-flat-button (click)="cancel()">
          <div class="button-text">Cancel</div>
        </button>
        <button class="button-action" mat-flat-button color="primary" (click)="save()">
          <div class="button-text">Save</div>
        </button>
      }

    <span class="body-2-default color-text-secondary">
      {{ totalSelected }} industries selected
    </span>
    </div>
    <span class="fx-spacer"></span>

    <mat-form-field class="custom-text-field search-field" appearance="outline">
      <mat-label>Search categories and industries...</mat-label>
      <input matInput [(ngModel)]="searchTerm" (ngModelChange)="onSearchChange()">
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    @if (!this.searchTerm.trim()) {
      <button mat-icon-button [disabled]="!!(loader.loading$ | async)" (click)="onSearchChange()"
              matTooltip="Filter data">
        <mat-icon color="primary">filter_alt</mat-icon>
      </button>
    } @else {
      <button mat-icon-button [disabled]="!!(loader.loading$ | async)" (click)="clearSearch()"
              matTooltip="Clear filters">
        <mat-icon color="primary">filter_alt_off</mat-icon>
      </button>
    }

    <button mat-icon-button class="refresh-button" matTooltip="Refresh data">
      <mat-icon *ngIf="!(loader.loading$ | async)" color="primary">refresh</mat-icon>
      <mat-spinner diameter="20" *ngIf="(loader.loading$ | async)"></mat-spinner>
    </button>

  </div>

  <!-- Categories Grid -->
  <div class="categories-container">
    <div class="categories-grid">
      <app-industry-category-card
        *ngFor="let category of filteredCategories; trackBy: trackByCategoryId"
        [category]="category"
        (categoryChanged)="onCategoryChanged($event)"
        (addIndustryToCategory)="onAddIndustryToCategory($event)">
      </app-industry-category-card>
    </div>
  </div>
  <mat-divider fxFlexOffset="30px"></mat-divider>
</div>
